module.exports = __webpack_public_path__ + "img/homepage_1--mobile.40a94635.jpg";